module.exports = __webpack_public_path__ + "static/sf-ui-semibold-737321967d20f8d337aec06b34d47e8c.woff";